import { useMutation } from '@tanstack/react-query'
import { ApiQueryKeys, SettingsTypes } from 'globals/constants'
import { useSettings } from 'hooks/settings/settings.hook'
import { useSnackbar } from 'notistack'
import { FeedBackApi, FeedbackPayload } from 'sdk'
import { useAppDispatch } from 'store/app.store'
import { setIsAppFeedBackDialogOpen } from 'store/slices/common.slice'

export const useFeedBack = () => {
  const feebackApi = new FeedBackApi()
  const { enqueueSnackbar } = useSnackbar()
  const { UpdateSettings, loadDefaultSettings } = useSettings()
  const dispatch = useAppDispatch()

  const { mutateAsync: SaveFeedBack, isPending: IsSaving } = useMutation({
    mutationFn: (data: FeedbackPayload) => feebackApi.AddFeedback(data),
    mutationKey: [ApiQueryKeys.feedback.addFeedback],
    onError: (err) => enqueueSnackbar(err.message, { variant: 'error' }),
    onSuccess: () => {
      dispatch(setIsAppFeedBackDialogOpen(false))
      enqueueSnackbar('Feedback submitted successfully', { variant: 'success' })
      UpdateSettings([
        {
          Status: false,
          UniqueKey: SettingsTypes.TOUR_SETTINGS,
          Value: new Date().toUTCString(),
          AllowDuplicate: true,
        },
      ])
        .then((x) => {
          loadDefaultSettings()
        })
        .catch((x) => {})
    },
  })
  return {
    SaveFeedBack,
    IsSaving,
  }
}
